// The billing routes (our subscription, through the provider's hosted checkout), for Company's parts and
// Setup › Your plan and data.
import { refusalOf, RpcError } from '@flowology/client';
import { client } from '../api.ts';

/** The billing routes are plain HTTP (not actions), so a read-only company can always pay. */
export async function billing<T>(method: 'GET' | 'POST', path: string): Promise<T> {
  const csrf = method === 'POST' ? (await client.session())?.csrf : undefined;
  const res = await fetch(path, {
    method,
    credentials: 'same-origin',
    headers: {
      ...(method === 'POST' ? { 'content-type': 'application/json' } : {}),
      ...(csrf ? { 'x-flow-csrf': csrf } : {}),
    },
    ...(method === 'POST' ? { body: '{}' } : {}),
  });
  const body = (await res.json().catch(() => null)) as {
    ok?: boolean;
    result?: T;
    error?: unknown;
  } | null;
  // A refusal says what to do, ours or the way there's (a 413, a proxy's 502), as the client does.
  if (!res.ok || !body?.ok) throw new RpcError(res.status, refusalOf(res.status, body));
  return body.result as T;
}
